import {useNavigate, useParams} from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../config/AuthContext";
import Beca from "../../../model/multilleure/extraescolars/Beca";
import Table, { ColumnsType, TableProps } from "antd/es/table";
import Colors from "../../../styles/Colors";
import { BiRefresh, BiSearch } from "react-icons/bi";
import { Button, Card, DatePicker, Form, Select } from "antd";
import NavBar from "../../components/NavBar";
import { Toaster } from "react-hot-toast";
import Historials from "../../components/Historials";
import Login from "../../root/Login";
import { Escola } from "../../../model/root/Escola";
import { GetEscoles } from "../../../dao/root/GetEscoles";
import { GetBecatsPerEscolaCursSencer } from "../../../dao/multilleure/extraescolars/GetBecatsPerEscolaCursSencer";
import dayjs, {Dayjs} from 'dayjs';
import { BsFileExcel, BsFilePdf } from "react-icons/bs";
import { PostGenerarCursSencerExcel } from "../../../dao/multilleure/extraescolars/PostGenerarBequesCursSencerExcel";

const Beques = () => {
    const titol: string = "Beques";
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<Beca[]>([]);
    const [escoles, setDadesE] = useState<{ value: string; label: string; }[]>([]);
    const [elementSelected, setElementSelected] = useState<Beca>(new Beca());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [form] = Form.useForm();
    const [documentUrlPdf, setDocumentUrlPdf] = useState<string | undefined>("");
    const [bequesSearched, setBequesSearched] = useState(false);

    async function checkListas(){
        const escoles = await GetEscoles(page);
        const escolesList = escoles.map((element: Escola) => ({
            value: element.id_loop,
            label: element.nom,
        }));
        setDadesE(escolesList);
    }
    useEffect(() => {
        console.log("coleccio:", coleccio);
        console.log("Es array:", Array.isArray(coleccio));
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkListas();
        }
    }, [id]);
    async function checkDades() {
        const idcent = await form.getFieldValue('idcent');
        const curs: Dayjs = await form.getFieldValue('curs');
        const year = curs.year();
        console.log("idcent ", idcent, " type ", typeof(idcent));
        console.log("curs ", year, " type ", typeof(year));
        const dades = await GetBecatsPerEscolaCursSencer(page, idcent, year);
        setDades(dades);
        setBequesSearched(true);
        //await setNameFilters(dades);
    }
    function toggleTable() {
        setVisible(!visible);
    }

    function afegirElement(element: Beca) {
        setNouElement(!nouElement);
        setEditar(true);
        setElementSelected(element);
    }

    function togleNouElement(element: Beca, edit : boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }

    function handleCloseModal() {
        setNouElement(false);
        checkDades();
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Beca[]) {
        const anyNames = elements.map((element) => ({
            text: element.nom_alumne,
            value: element.nom_alumne,
        }));
        setNomFiltres(anyNames);
    }

    const columns: ColumnsType<Beca> = [
        {
            key: 'idclas',
            title: 'Classe',
            dataIndex: 'idclas',
            width: 15
        },
        {
            key: 'idalum',
            title: 'ID Alumne',
            dataIndex: 'idalum',
            width: 15
        },
        {
            key: 'nom_alumne',
            title: 'Nom alumne',
            dataIndex: 'nom_alumne',
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom_alumne.includes(value) : false),
            width: 30
        },
        {
            key: 'serveis',
            title: 'Num serveis',
            dataIndex: 'serveis',
            width: 15
        },
        {
            key: 'menbec1',
            title: 'Beca CC',
            dataIndex: 'menbec1',
            width: 15
        },
        {
            key: 'menbec2',
            title: 'Beca Aj',
            dataIndex: 'menbec2',
            width: 15
        },
        {
            key: 'import_bea',
            title: 'Import beca',
            dataIndex: 'import_bea',
            width: 30
        },
        {
            key: 'import_AMB',
            title: 'Import AMB',
            dataIndex: 'import_AMB',
            width: 30
        },
        {
            key: 'import_ajunt',
            title: 'Import Ajunt',
            dataIndex: 'import_ajunt',
            width: 30
        },
    ];
    const tableProps: TableProps<Beca> = {

    };
    const onChange: TableProps<Beca>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };
    
    async function handleDownload() {
        const idcent = await form.getFieldValue('idcent');
        const curs: Dayjs = await form.getFieldValue('curs');
        const year = curs.year();
        const json = {idcent, year};

        setLoading(true);
        const documentUrl = await PostGenerarCursSencerExcel(json, page);
        setDocumentUrlPdf(documentUrl);

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `Beques${idcent}${year}.xlsx`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };
    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    
                    <Card bordered={true} className={"elemento"}>
                        <h4 className={"titol"} style={{marginBottom: 16}}>{titol}</h4>

                        {/* Filtres en una sola fila: escola + any + accions */}
                        <Form form={form} layout="inline" style={{
                            display: 'flex', alignItems: 'center', gap: 8,
                            flexWrap: 'wrap', marginBottom: 16, width: '100%'
                        }}>
                            <span>Escola:</span>
                            <Form.Item name="idcent" style={{marginBottom: 0, marginInlineEnd: 0}}>
                                <Select
                                    showSearch
                                    placeholder="Selecciona una escola"
                                    optionFilterProp="label"
                                    options={escoles}
                                    style={{width: 240}}
                                />
                            </Form.Item>

                            <span>Any:</span>
                            <Form.Item name="curs" style={{marginBottom: 0, marginInlineEnd: 0}}>
                                <DatePicker picker="year" style={{width: 120}}/>
                            </Form.Item>

                            <Button title={"Cercar"} icon={<BiSearch/>}
                                    style={{backgroundColor: Colors.colors.color1, color: '#fff'}}
                                    onClick={checkDades}/>
                            <Button title={"Descarregar dades"} icon={<BsFileExcel/>}
                                    onClick={handleDownload}
                                    disabled={!bequesSearched}
                                    style={{backgroundColor: Colors.colors.color4}}/>
                            <Button title={"Refrescar"} icon={<BiRefresh/>}
                                    style={{backgroundColor: Colors.colors.color4}}
                                    onClick={() => checkListas()}/>
                        </Form>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                rowKey="idcent"
                                columns={columns}
                                dataSource={Array.isArray(coleccio) ? coleccio : []}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={titol} pagina={page}/>
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Beques;